import React, { useEffect, useState } from 'react';
import {
    Alert,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container, Input, Label,
    Row
} from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import {AppointmentAPI,} from 'api';

import {Loading, Utils} from 'custom';

import BookingTabDay from "./Tab/BookingTabDay";
import BookingTabMonth from "./Tab/BookingTabMonth";
import {useLocation} from "react-router-dom";

const moment = require("moment");

const AppointmentsSection = () => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);
    const [appointments, setAppointments] = useState([]);
    const [daysRange, setDaysRange] = useState({
        startDay: moment().clone().startOf('month').toISOString(),
        endDay: moment().clone().endOf('month').toISOString()
    });

    const location = useLocation();


    useEffect(() => {
        getAppointments();
    }, [daysRange]);


    let getAppointments = async () => {
        try {
            let resAppointments = await AppointmentAPI.list(moment(daysRange.startDay).format("YYYY-MM-DD"), moment(daysRange.endDay).format("YYYY-MM-DD"));
            if (resAppointments) {
                setAppointments(resAppointments);
            }

            setLoading(false);
        } catch (e) {
            setError(true);
        }
    };

    if (error)
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Appuntamenti" pageTitle={process.env.REACT_APP_NAME} />
                        <Row>
                            <Col lg={12}>
                                <Alert color="danger">Si è verificato un errore durante il recupero degli appuntamenti</Alert>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <Row className={"mt-3"}>
                        <Col md={12} lg={12} xl={12}>
                            <Card>
                                <CardHeader>
                                    <h5>Calendario</h5>
                                </CardHeader>
                                <CardBody>
                                    {(loading) ? <Loading  /> : <BookingTabMonth setDaysRange={setDaysRange} appointments={appointments} selectedDay={selectedDay} setSelectedDay={setSelectedDay} />}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} lg={12} xl={12}>
                            <Card>
                                <CardHeader>
                                    {(!loading) ? <div>
                                        <h6 className="m-2">Prenotazioni per il giorno</h6>
                                        <h5 className="m-2">{moment(selectedDay, "YYYY-MM-DD").format("dddd DD MMMM YYYY")}</h5>
                                    </div> : null}
                                </CardHeader>
                                <CardBody>
                                    {(loading) ? <Loading  /> : <BookingTabDay selectedDay={selectedDay} appointments={appointments} getAppointments={getAppointments}/>}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    );
}

export default AppointmentsSection;
